export const ADD_VISITOR_STARTED = 'ADD_VISITOR_STARTED';
export const ADD_VISITOR_COMPLETED = 'ADD_VISITOR_COMPLETED';
export const ADD_VISITOR_ERROR = 'ADD_VISITOR_ERROR';

export const FETCH_VISITORS_STARTED = 'FETCH_VISITORS_STARTED';
export const FETCH_VISITORS_COMPLETED = 'FETCH_VISITORS_COMPLETED';
export const FETCH_VISITORS_ERROR = 'FETCH_VISITORS_ERROR';

export const ADD_VISITORDETAIL_STARTED = 'ADD_VISITORDETAIL_STARTED';
export const ADD_VISITORDETAIL_COMPLETED = 'ADD_VISITORDETAIL_COMPLETED';

export const UPDATE_VISITOR_STARTED = 'UPDATE_VISITOR_STARTED';
export const UPDATE_VISITOR_COMPLETED = 'UPDATE_VISITOR_COMPLETED';
export const UPDATE_VISITOR_ERROR = 'UPDATE_VISITOR_ERROR';



// WEBPACK FOOTER //
// ./src/redux/actionTypes/visitorActionTypes.js